'use client'

import Breadcrumbs from './Breadсrumbs'

export { Breadcrumbs }

export default Breadcrumbs
